import { render, staticRenderFns } from "./TepLiquidacionPlantilla.vue?vue&type=template&id=c286f7fa"
import script from "./TepLiquidacionPlantilla.vue?vue&type=script&lang=js"
export * from "./TepLiquidacionPlantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports